import { noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import BlockView from '@src/components/battle/demo/blocks/BlockView'
import { Block } from '@src/types/pageBuilder'

const Container = styled(Box)`
  position: relative;
  width: 100%;
  display: flex;
  column-gap: 24px;
  row-gap: 40px;

  ${props => props.theme.breakpoints.down('res768')} {
    flex-direction: column;
  }
`

const Column = styled(Box, noForwardProps)<{ __width: string }>`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  ${props => props.theme.breakpoints.up('res768')} {
    width: ${({ __width }) => __width};
  }
`

type Props = {
  cols: Block[][]
}

const RowBlockView = ({ cols }: Props) => {
  return (
    <Container>
      {cols.map((blocks, index) => {
        const key = `row-${index}`

        return (
          <Column key={key} __width={`${100 / cols.length}%`}>
            {blocks.map((block, index) => {
              const key = `${block.type}-${index}`

              return <BlockView key={key} block={block} />
            })}
          </Column>
        )
      })}
    </Container>
  )
}

export default RowBlockView
